import { Link } from "react-router-dom";

const columns = [
  {
    title: "评选专区",
    links: [
      { to: "/finalists", label: "入围名单" },
      { to: "/ranking", label: "排名结果" },
      { to: "/finalists", label: "分类浏览" },
    ],
  },
  {
    title: "了解活动",
    links: [
      { to: "/about", label: "关于我们" },
      { to: "/faq", label: "常见问题" },
      { to: "/ranking", label: "群众打分说明" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center text-xl">
                <i className="ri-fire-fill" />
              </span>
              <span className="font-heading text-xl tracking-wide text-background-50">爆料大赛</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200 max-w-md">
              一个由网友共同打分的趣味爆料评选舞台。浏览入围名单、围观群众打分走势，为你心中的名场面投上一票。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-background-50/10 flex items-center justify-center">
                <i className="ri-mail-line text-lg" />
              </span>
              <div className="text-sm">
                <p className="text-background-300">活动咨询与违规反馈</p>
                <a href="mailto:hello@baoliaodasai.net" className="text-background-50 hover:text-accent-300 transition-colors">
                  hello@baoliaodasai.net
                </a>
              </div>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-base text-background-50 mb-4 tracking-wide">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-sm text-background-200 hover:text-accent-300 transition-colors">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© 2026 爆料大赛 · 内容由网友投稿并经初审后展示</p>
          <p>本站评分仅代表网友观点，不构成任何事实认定</p>
        </div>
      </div>
    </footer>
  );
}